"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BC_PIXELS_MAX = exports.BC_XL = exports.BC_LG = exports.BC_MD = exports.BC_SM = exports.BC_XS = exports.BC_SUBMENU_PADDING_BOTTOM = exports.BC_MEGA_MENU_COLUMN = exports.BC_MEGA_MENU_COLUMNS = exports.BC_MEGA_MENU_3_COLUMNS = exports.BC_MENU_SUBMENU_WIDTH = exports.BC_MENU_HAS_LOG_OUT = exports.BC_MENU_LOG_OUT_EVENT = exports.BC_MENU_VALIDATE_MAX = exports.BC_MENU_LOG_OUT_TEXT = exports.BC_MENU_LOG_OUT = exports.BC_MENU_BUTTON_OPEN_ITEMS_TEXT = exports.BC_MENU_CLOSE_STATE = exports.BC_MENU_OPEN_STATE = exports.BC_MENU_OUTSIDECLICK = exports.BC_MENU_ITEM_OPTIONS_ACTIVE = exports.BC_MENU_ITEM_OPTIONS = exports.BC_MENU_SUBMENU_INSIDE = exports.BC_MENU_SUBMENU_TITLE = exports.BC_MENU_SUBMENU_FOOTER_CONTAINER = exports.BC_MENU_SUBMENU_CONTAINER = exports.BC_MENU_SUBMENU_ACTIVE = exports.BC_MENU_SUBMENU = exports.BC_MENU_COLUMNS = exports.MAX_ITEMS = exports.BC_CLOSE_BUTTON = exports.BC_MENU_FOOTER = exports.BC_MENU_MAIN_CONTENT_MD_HIDDEN = exports.BC_MENU_MAIN_CONTENT_MD = exports.BC_MENU_MAIN_CONTENT_SM_VISIBLE = exports.BC_MENU_MAIN_CONTENT_SM = exports.BC_MENU_MAIN_CONTENT_ACTIVE = exports.BC_MENU_MAIN_CONTENT = exports.BC_MENU_ITEM_ACTIVE = exports.BC_MENU_ITEM = exports.BC_MENU_DRAWER_ACTIVE = exports.BC_MENU_DRAWER = exports.BC_MENU_COLUMN = exports.BC_MENU_HEADER_HIDDEN = exports.BC_MENU_HEADER = exports.BC_MENU_CONTENT_BODY_ACTIVE = exports.BC_MENU_CONTENT_GLOBAL = exports.BC_MENU_CONTENT_BODY = exports.BC_MENU_CONTENT_BODIES = exports.BC_MENU = void 0;
exports.TAGS_MENU_LIST = exports.CLASS_MENU_LIST = exports.OPEN_STATE = exports.ACTIVE_STATE = exports.COLLAPSED_STATE = exports.STATE = exports.BC_DRAWER_ERROR = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_MENU = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu");
exports.BC_MENU_CONTENT_BODIES = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-bodies");
exports.BC_MENU_CONTENT_BODY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-body");
exports.BC_MENU_CONTENT_GLOBAL = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-global-container");
exports.BC_MENU_CONTENT_BODY_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-body-active");
exports.BC_MENU_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-header");
exports.BC_MENU_HEADER_HIDDEN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-header-hidden");
exports.BC_MENU_COLUMN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-column");
exports.BC_MENU_DRAWER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-drawer-content");
exports.BC_MENU_DRAWER_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-drawer-content-active");
exports.BC_MENU_ITEM = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-item");
exports.BC_MENU_ITEM_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-item-active");
exports.BC_MENU_MAIN_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-main-content");
exports.BC_MENU_MAIN_CONTENT_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-main-content-active");
exports.BC_MENU_MAIN_CONTENT_SM = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-sm");
exports.BC_MENU_MAIN_CONTENT_SM_VISIBLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-sm-visible");
exports.BC_MENU_MAIN_CONTENT_MD = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-md");
exports.BC_MENU_MAIN_CONTENT_MD_HIDDEN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-content-md-hidden");
exports.BC_MENU_FOOTER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-drawer-content-footer");
exports.BC_CLOSE_BUTTON = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-icon ").concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-sm");
exports.MAX_ITEMS = 7;
exports.BC_MENU_COLUMNS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-columns-properties");
exports.BC_MENU_SUBMENU = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-submenu");
exports.BC_MENU_SUBMENU_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-submenu-active");
exports.BC_MENU_SUBMENU_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-container");
exports.BC_MENU_SUBMENU_FOOTER_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-footer-container");
exports.BC_MENU_SUBMENU_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-title");
exports.BC_MENU_SUBMENU_INSIDE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-submenu-inside");
exports.BC_MENU_ITEM_OPTIONS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-item-options");
exports.BC_MENU_ITEM_OPTIONS_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-options-active");
exports.BC_MENU_OUTSIDECLICK = "hasOutsideClick";
exports.BC_MENU_OPEN_STATE = "open";
exports.BC_MENU_CLOSE_STATE = "close";
exports.BC_MENU_BUTTON_OPEN_ITEMS_TEXT = "M\u00E1s";
exports.BC_MENU_LOG_OUT = "CERRAR SESI\u00D3N";
exports.BC_MENU_LOG_OUT_TEXT = "logOutButtonText";
exports.BC_MENU_VALIDATE_MAX = "validateMaxItems";
exports.BC_MENU_LOG_OUT_EVENT = "logOutEvent";
exports.BC_MENU_HAS_LOG_OUT = "logOutButton";
exports.BC_MENU_SUBMENU_WIDTH = "740px";
exports.BC_MEGA_MENU_3_COLUMNS = '728px';
exports.BC_MEGA_MENU_COLUMNS = '496px';
exports.BC_MEGA_MENU_COLUMN = '264px';
exports.BC_SUBMENU_PADDING_BOTTOM = '16px';
exports.BC_XS = 0;
exports.BC_SM = 576;
exports.BC_MD = 768;
exports.BC_LG = 992;
exports.BC_XL = 1200;
exports.BC_PIXELS_MAX = 58;
exports.BC_DRAWER_ERROR = 'The drawer is not present in the DOM';
exports.STATE = 'state';
exports.COLLAPSED_STATE = 0;
exports.ACTIVE_STATE = 1;
exports.OPEN_STATE = 2;
exports.CLASS_MENU_LIST = [
    'BC_MENU_CONTENT_GLOBAL',
    'BC_MENU_DRAWER',
    'BC_MENU_ITEM_ACTIVE',
    'BC_MENU_ITEM',
    'BC_MENU_MAIN_CONTENT',
    'BC_MENU_HEADER',
    'BC_MENU_CONTENT_BODY',
    'BC_MENU_SUBMENU_FOOTER_CONTAINER',
    common_constants_1.BcCommonConstants.BC_BTN_CLASS,
    common_constants_1.BcCommonConstants.EXPANDED,
    'BC_MENU_DRAWER_ACTIVE',
    'BC_MENU_COLUMN',
    'BC_MENU_CONTENT_BODIES',
    common_constants_1.BcCommonConstants.BUTTON_FAB_CLASS
];
exports.TAGS_MENU_LIST = [
    {
        tag: common_constants_1.BcCommonConstants.UL_TAG,
        parent: 'BC_MENU_ITEM'
    },
    {
        tag: common_constants_1.BcCommonConstants.ICONS_CLASS,
        parent: ''
    },
    {
        tag: common_constants_1.BcCommonConstants.EM_TAG,
        parent: ''
    },
    {
        tag: common_constants_1.BcCommonConstants.LI_TAG,
        parent: 'BC_MENU_ITEM'
    },
    {
        tag: common_constants_1.BcCommonConstants.DIV_TAG,
        parent: ''
    },
    {
        tag: common_constants_1.BcCommonConstants.DIV_TAG,
        parent: 'BC_MENU_DRAWER'
    },
    {
        tag: common_constants_1.BcCommonConstants.BUTTON_TAG,
        parent: 'BC_MENU_SUBMENU_FOOTER_CONTAINER'
    }
];
